import type { SignerStep } from 'signer-app/signer-experience/types';
import {
  MessageType,
  postMessage,
  useWindowMessage,
} from 'signer-app/utils/messages';

const TERMINAL_SIGNER_STEPS: ReadonlySet<SignerStep> = new Set([
  'complete',
  'declineComplete',
  'delegateComplete',
]);

export function useCancelRequestResponse(
  step: SignerStep,
  parentUrl: string | undefined,
) {
  useWindowMessage(
    MessageType.USER_CANCEL_REQUEST,
    () => {
      if (!parentUrl) {
        return;
      }

      postMessage(
        {
          type: TERMINAL_SIGNER_STEPS.has(step)
            ? MessageType.USER_FINISH_REQUEST
            : MessageType.USER_CANCEL_REQUEST,
        },
        parentUrl,
      );
    },
    { expectedOrigin: parentUrl },
  );
}
